var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandAr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.834,
    height: 47.558,
    viewBox: "0 0 47.834 47.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    transform: "translate(-3355.364 -1540.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_awesome-expand",
    "data-name": "Icon awesome-expand",
    transform: "translate(3368.525 1553.265)",
    fill: "red",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.511,7.253.5,1.6A1.093,1.093,0,0,1,1.6.5H7.276A.546.546,0,0,1,7.49.543a.554.554,0,0,1,.293.292.542.542,0,0,1,.043.213V2.874a.541.541,0,0,1-.043.213.553.553,0,0,1-.292.292.545.545,0,0,1-.213.043H3.434l0,3.832a.54.54,0,0,1-.043.212A.549.549,0,0,1,2.89,7.8H1.06a.546.546,0,0,1-.213-.043.554.554,0,0,1-.293-.292A.541.541,0,0,1,.511,7.253ZM13.685,1.048V2.874a.541.541,0,0,0,.043.213.554.554,0,0,0,.293.292.545.545,0,0,0,.213.043h3.844l0,3.832a.541.541,0,0,0,.043.212.55.55,0,0,0,.505.335h1.83a.546.546,0,0,0,.213-.043.554.554,0,0,0,.293-.292A.541.541,0,0,0,21,7.253l0-5.658a1.094,1.094,0,0,0-1.1-1.1H14.235a.545.545,0,0,0-.213.043.554.554,0,0,0-.293.292A.542.542,0,0,0,13.685,1.048ZM20.45,13.633H18.622a.545.545,0,0,0-.213.043.553.553,0,0,0-.292.291.54.54,0,0,0-.043.212l0,3.823H14.233a.545.545,0,0,0-.213.043.552.552,0,0,0-.292.291.539.539,0,0,0-.043.212v1.819a.538.538,0,0,0,.043.212.549.549,0,0,0,.5.334H19.9a1.1,1.1,0,0,0,.776-.319,1.086,1.086,0,0,0,.321-.772l0-5.642a.539.539,0,0,0-.043-.212.549.549,0,0,0-.5-.334ZM7.837,20.368V18.548a.539.539,0,0,0-.043-.212A.55.55,0,0,0,7.288,18H3.45l0-3.823a.54.54,0,0,0-.044-.212.55.55,0,0,0-.506-.334H1.068a.545.545,0,0,0-.213.043.552.552,0,0,0-.292.291.539.539,0,0,0-.043.212l.008,5.642a1.092,1.092,0,0,0,.67,1.006,1.1,1.1,0,0,0,.428.085H7.29A.545.545,0,0,0,7.5,20.87a.552.552,0,0,0,.292-.291A.538.538,0,0,0,7.837,20.368Z",
    stroke: "none"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_109",
    "data-name": "Ellipse 109",
    d: "M23.917,0A23.769,23.769,0,1,1,.077,23.841,23.652,23.652,0,0,1,7.022,7,23.8,23.8,0,0,1,23.917,0Z",
    transform: "translate(3355.364 1540.192)",
    fill: "#522600",
    opacity: 0.471
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandAr);
export default __webpack_public_path__ + "static/media/expand-ar.6e43760c02b384b9f4f73005890d5e73.svg";
export { ForwardRef as ReactComponent };